import React from 'react'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import FlexGroup from 'Components/FlexGroup'
import ArrowBack from 'Svgs/ArrowLeft'
import PropTypes from 'prop-types'

const TextWithBackButton = ({
  text,
  variant,
  backButtonVisible,
  right,
  backClicked,
}) => (
  <FlexGroup
    left={<div />}
    middle={
      <Typography className="text-gray-700 text-2xl mb-2" variant={variant}>
        {backButtonVisible && (
          <IconButton
            aria-label="Back"
            color="primary"
            className="mr-2"
            onClick={backClicked}
          >
            <ArrowBack className="h-6" />
          </IconButton>
        )}
        {text}
      </Typography>
    }
    right={right}
  />
)

TextWithBackButton.defaultProps = {
  backClicked: () => {},
  backButtonVisible: false,
  variant: 'h5',
  right: <div />,
}

TextWithBackButton.propTypes = {
  text: PropTypes.string.isRequired,
  backClicked: PropTypes.func,
  variant: PropTypes.string,
  backButtonVisible: PropTypes.bool,
  right: PropTypes.node,
}

export default TextWithBackButton
